import React from 'react'
import MainContentSubAccessories from '../MainContentSubAccessories'

const TabletCaseSub = () => {
  return (
    <div className='pageAccessories bg-accessories-sub-page'>
        <MainContentSubAccessories parentCate={'Phụ kiện'}  
            childCate={'Ốp lưng máy tính bảng'} 
            // listProduct={listProductSub}
    />
</div>
  )
}

export default TabletCaseSub
